import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import { Select } from '@seeqdev/qomponents';
import type { WorkbookApprovalFlow } from '@/worksheet/worksheet.types';

const SELECT_DESCRIPTION_ID = 'applyApprovalFlowSelectDescription';

type ApprovalFlowSelectProps = {
  availableFlows: WorkbookApprovalFlow[];
  selectedFlowId?: string;
  onSelectedFlowIdChange: (flowId: string | undefined) => void;
  itemType: string;
  isDisabled: boolean;
  menuIsOpen: boolean;
  onMenuOpen: () => void;
  onMenuClose: () => void;
};

export const ApprovalFlowSelect = ({
  availableFlows,
  selectedFlowId,
  onSelectedFlowIdChange,
  itemType,
  isDisabled,
  menuIsOpen,
  onMenuOpen,
  onMenuClose,
}: ApprovalFlowSelectProps) => {
  const { t } = useTranslation();
  const flowOptions = availableFlows.map((flow) => ({ value: flow.id, label: flow.name }));

  return (
    <>
      <div id={SELECT_DESCRIPTION_ID} data-testid={SELECT_DESCRIPTION_ID}>
        {t('APPROVAL_FLOWS.SELECT_FLOW_DESCRIPTION', { itemType })}
      </div>
      <div {...stylex.props(styles.field)}>
        <label htmlFor="applyApprovalFlowSelect" {...stylex.props(styles.fieldLabel)}>
          {t('APPROVAL_FLOWS.FLOW_LABEL')}
        </label>
        <Select
          inputId="applyApprovalFlowSelect"
          testId="applyApprovalFlowSelect"
          ariaDescribedBy={SELECT_DESCRIPTION_ID}
          value={flowOptions.find((option) => option.value === selectedFlowId)}
          options={flowOptions}
          onChange={(option) => onSelectedFlowIdChange(option?.value)}
          menuIsOpen={menuIsOpen}
          onMenuOpen={onMenuOpen}
          onMenuClose={onMenuClose}
          placeholder={t('APPROVAL_FLOWS.SELECT_FLOW_PLACEHOLDER')}
          isDisabled={isDisabled}
          // The modal body scrolls, so an inline menu would be clipped to the few pixels below the control.
          menuPortalTarget={document.body}
        />
      </div>
    </>
  );
};

const styles = stylex.create({
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
  },
  fieldLabel: {
    fontWeight: 'bold',
  },
});
